import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames/bind';

import { call, offsetParents, getViewportHeight, getViewportWidth } from '../utils';

import styles from './Menu.less';

const cxb = cx.bind(styles);

/**
 * **Access:**
 * ```js
 * import { Flyouts } from '@iss/client-react-components'
 *
 * <Flyouts.Menu/>
 * ```
 *
 *
 */
export default class Menu extends React.Component {
  static propTypes = {
    condensed: PropTypes.bool,

    constrain: PropTypes.bool,
    focus: PropTypes.bool,

    onDismiss: PropTypes.func,

    kind: PropTypes.oneOf(['light', 'dark', 'special', 'special-dark']).isRequired,
  };

  static defaultProps = {
    focus: true,
    kind: 'light',
  };

  ref = React.createRef();

  componentDidMount() {
    this.constrain();
    if (this.props.focus) {
      focus(this.ref.current);
    }
  }

  componentDidUpdate() {
    this.constrain();
  }

  constrain() {
    const {
      ref: { current: el },
    } = this;
    if (this.props.constrain && el) {
      const sum = (s) => (a, e) => {
        a.top += e[s + 'Top'];
        a.left += e[s + 'Left'];
        return a;
      };

      const rect = el.getBoundingClientRect();
      let { top, left } = offsetParents(el).reduce(sum('offset'), { top: 0, left: 0 });

      if (top > getViewportHeight()) {
        top = rect.top;
      }

      if (left > getViewportWidth()) {
        left = rect.left;
      }

      // handle max-height calculation when dropdown is open upwards(top < 0)
      Object.assign(el.style, {
        maxHeight: top < 0 ? `${rect.bottom}px` : `calc(100vh - ${top}px)`,
        maxWidth: `calc(100vw - ${left}px)`,
      });
    }
  }

  render() {
    const { className, children, condensed, constrain, onDismiss, kind, focus, ...props } = this.props;

    const close = () => call(onDismiss);

    return (
      <ul {...props} className={cxb('root', kind, className, { condensed, constrain })} ref={this.ref} onClick={close}>
        {React.Children.map(children, (child) => (
          <li className={cxb('item')}>{React.cloneElement(child, { kind, condensed })}</li>
        ))}
      </ul>
    );
  }
}

function focus(el) {
  if (!el) return;

  el = el.querySelector('a,button') || el;

  /* istanbul ignore else */
  if (el) {
    //wait for it to be visible
    setTimeout(() => el.focus(), 300);
  }
}
